export const navVariantCssClassNames = {
    variantTop: 'Nav-variantTop',
    variantSide: 'Nav-variantSide',
    variantFixedSide: 'Nav-variantFixedSide'
};

export const navDrawerCssClassNames = {
    drawer: 'Nav-drawer',
    drawerHeader: 'Nav-drawerHeader',
    drawerHeaderText: 'Nav-drawerHeaderText',
    drawerBox: 'Nav-drawerBox',
    drawerNav: 'Nav-drawerNav',
    drawerList: 'Nav-drawerList'
};

export const navItemCssClassNames = {
    item: 'Nav-item',
    itemButton: 'Nav-itemButton',
    itemButtonText: 'Nav-itemButtonText'
};

export const navItemCollapseCssClassNames = {
    itemCollapseButton: 'Nav-itemCollapseButton',
    itemCollapseMenu: 'Nav-itemCollapseMenu'
};

export const navItemDrawerCssClassNames = {
    itemDrawerButton: 'Nav-itemDrawerButton'
};

export const navItemDropdownCssClassNames = {
    itemDropdownButton: 'Nav-itemDropdownButton',
    itemDropdownMenu: 'Nav-itemDropdownMenu'
};

export const navBaseCssClassNames = {
    root: 'Nav-root',
    list: 'Nav-list'
};

export const navCssClassNames = {
    ...navVariantCssClassNames,
    ...navDrawerCssClassNames,
    ...navItemCssClassNames,
    ...navItemCollapseCssClassNames,
    ...navItemDrawerCssClassNames,
    ...navItemDropdownCssClassNames,
    ...navBaseCssClassNames
};
